import dayjs from 'dayjs';

export default {
  refreshToCurrentTime(state) {
    state.unixTs = dayjs().unix();
  },

  modifyIsInitialLoading(state, payload) {
    state.isInitialLoading = payload;
  },
  modifyTimestamp(state, payload) {
    state.timestamp = payload;
  },
  setTotalAttacks(state, payload) {
    state.totalAttacks = payload;
  },
  modifyAttackDataLoading(state, payload) {
    state.attackDataLoading = payload;
  },
  addAttackData(state, attackData) {
    state.attackData = [...attackData];
  },
  modifyTopIPLoading(state, payload) {
    state.topIPLoading = payload;
  },
  addTopIP(state, newTopIPData) {
    state.topIP = [...newTopIPData];
  },
  addSVGCountries(state, svgArray) {
    state.svgCountries = [...svgArray];
  },
  changeCurrentAttacks(state, newAttacks) {
    state.currentAttacks = [...newAttacks];
  },
  modifyAttackData(state, remainingAttacks) {
    state.attackData = [...remainingAttacks];
  },
  refreshLastFiveAttack(state, payload) {
    state.lastFiveAttack = payload.slice(0, 5);
  },
  setAttackDataCache(state, payload) {
    state.attackDataCache = [...state.attackDataCache, ...payload];
  },
  refreshAttackDataCache(state, payload) {
    state.attackDataCache = payload;
  }
};
